var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`width: 100%; height: 100%; min-height: 350px; max-height: 550px; min-width: 200px; ${_vm.height ? 'height: ' + _vm.height + 'px' : ''}`),attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }